import { useContext } from 'react';
import { ConfigContext } from './ConfigContext';

/**
 * Custom hook to consume the ConfigContext.
 * Provides access to configuration data, loading state, and error state.
 * 
 * @returns {Object} An object containing:
 *   - config: The configuration data object
 *   - loading: Boolean indicating if config is being fetched
 *   - error: Error message if config fetch failed, null otherwise
 *   - hasConfig: Boolean indicating if config data is available
 * 
 * @example
 * const { config, loading, error, hasConfig } = useConfig();
 * 
 * if (loading) return <div>Loading configuration...</div>;
 * if (error) return <div>Error: {error}</div>;
 * if (!hasConfig) return <div>No configuration available</div>;
 * 
 * return <div>API URL: {config.apiUrl}</div>;
 */
export const useConfig = () => {
  const context = useContext(ConfigContext);
  
  if (context === undefined) {
    return {
      config: {},
      loading: false,
      error: null,
      hasConfig: false
    };
  }
  
  return context;
};
